import React from "react";
import { type Emoji } from "@matrix-org/emojibase-bindings";

interface IProps {
    emoji: Emoji;
}

class Preview extends React.PureComponent<IProps> {
    public render(): React.ReactNode {
        const {
            unicode = "",
            label = "",
            shortcodes = [],
        } = this.props.emoji;

        return (
            <div className="mx_EmojiPicker_footer mx_EmojiPicker_preview">
                <div className="mx_EmojiPicker_preview_emoji">{unicode}</div>
                <div className="mx_EmojiPicker_preview_text">
                    <div className="mx_EmojiPicker_name mx_EmojiPicker_preview_name">{label}</div>
                    {shortcodes.length > 0 && <div className="mx_EmojiPicker_shortcode">{shortcodes[0]}</div>}
                </div>
            </div>
        );
    }
}

export default Preview;
